<template xmlns="http://www.w3.org/1999/html">
  <el-dialog
    title="打印预览"
    :visible="visible"
    width="900px"
    :before-close="hideDialog"
    :close-on-click-modal="false"
  >
    <div id="surePricePrint">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContract"
        style="margin: 10px 0"
        >打印
      </el-button>
      <div
        ref="bidControlOederPrint"
        id="bidControlOederPrint"
        style="font-size: 16px; font-family: 宋体"
      >
        <div style="text-align: center; font-size: 30px; padding: 30px 0 20px">
          {{ formData.title }}
        </div>
        <div style="text-align: center; font-size: 20px"></div>
        <div style="font-size: 18px; padding-bottom: 10px">
          <div
            contenteditable="true"
            style="display: inline-block; float: right"
          >
            时间：{{ formatDate(formData.approveTime) }}
          </div>
        </div>
        <div style="border: 1px solid rgb(0, 0, 0); margin: 20px 0">
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              display: flex;
              min-height: 80px;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              提报单位/部门
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.commitDeptName }}
            </div>
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0);
                border-left: 1px solid rgb(0, 0, 0);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              审核内容
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.approveComment }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              display: flex;
              min-height: 80px;
              text-indent: 15px;
              padding: 4px;
              line-height: 22px;
            "
          >
            定额工作小组根据{{ formData.commitDeptName }}提报的{{
              formData.approveComment
            }}单价 分析进行了审核，审定单价为{{
              formData.approvePrice
            }}，此单价为招标控制价依据，后附单价 组成表。
          </div>

          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              min-height: 230px;
              padding: 4px;
            "
          >
            <div>定额工作小组成员意见（同意、附条件同意或不同意）：</div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in formData.options1"
                :key="index"
                style="
                  margin: 20px 40px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
              <div v-if="item.opinion">{{ item.opinion }}。</div>
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="100px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
                <!-- <div v-if="item.opinion">:{{ item.opinion }}</div> -->
              </div>
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0);
              min-height: 230px;
              page-break-inside: avoid;
              padding: 4px;
            "
          >
            <div>定额工作小组副组长意见（同意、附条件同意或不同意）：</div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in formData.options2"
                :key="index"
                style="
                  margin: 20px 40px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
              <div v-if="item.opinion">{{ item.opinion }}。</div>
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="100px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
                <!-- <div v-if="item.opinion">:{{ item.opinion }}</div> -->
              </div>
            </div>
          </div>
          <div
            style="min-height: 230px; page-break-inside: avoid; padding: 4px"
          >
            <div>定额工作小组组长意见（同意、附条件同意或不同意）：</div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
              "
            >
              <div
                v-for="(item, index) in formData.options3"
                :key="index"
                style="
                  margin: 20px 40px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div v-if="item.opinion">{{ item.opinion }}。</div>
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="100px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="printWrap" v-show="false">
        <div
          v-html="surePricePrintContent"
          class="mainHtml"
          id="printsurePricePrintContent"
        ></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import printJS from "print-js";

export default {
  name: "surePricePrint",
  props: {
    printData: {
      type: Object,
    },
    visible: {
      type: Boolean,
      defaule: false,
    },
  },
  data() {
    return {
      approveProcessList: [],
      surePricePrintContent: null,
    };
  },
  computed: {
    formData() {
      const filterApproveInfoList = this.printData.approveInfoList.filter(
        (i) => i.isPrint
      );
      const options1 = filterApproveInfoList.filter(
        (i) => i.opinionValue == "定额工作小组成员意见"
      );
      const options2 = filterApproveInfoList.filter(
        (i) => i.opinionValue == "定额工作小组副组长意见"
      );
      const options3 = filterApproveInfoList.filter(
        (i) => i.opinionValue == "定额工作小组组长意见"
      );

      return {
        ...this.printData,
        options1,
        options2,
        options3,
      };
    },
  },

  // mounted() {
  //   try {
  //     this.surePricePrintContent = this.$refs.bidControlOederPrint.innerHTML;
  //     this.surePricePrintContent =
  //       document.getElementById("bidControlOederPrint").innerHTML;
  //   } catch (err) {
  //     console.log(err);
  //   }
  // },
  methods: {
    hideDialog() {
      this.$emit("update:visible", false);
    },
    //打印当前合同
    PrintContract() {
      this.$set(
        this,
        "surePricePrintContent",
        this.$refs.bidControlOederPrint.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printsurePricePrintContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
        });
      });
    },
    formatDate(dateStr) {
      let date = new Date(dateStr);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return `${year}年${month}月${day}日`;
    },
  },
};
</script>
<style lang="scss">
#bidControlOederPrint {
  box-shadow: 0px 4px 12px 2px #bbb;
  position: relative;
  padding: 0 10px;
  width: 21cm;
  margin: 0 auto;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
